import AuthScreen from "../../../tags/auth-screen.marko";
import { flattenLocale, getLocaleStrings, t } from "../../lib/i18n.js";

<const/localeStrings=flattenLocale(getLocaleStrings("en"))>

<!DOCTYPE html>
<html lang="en">
<head>
  <meta charset="UTF-8">
  <meta name="viewport" content="width=device-width, initial-scale=1, viewport-fit=cover">
  <meta name="theme-color" content="#eef3eb">
  <meta name="robots" content="noindex, nofollow">
  <meta name="description" content=t("meta.description")>
  <title>${t("meta.loginTitle")}</title>
  <link rel="preconnect" href="https://fonts.googleapis.com">
  <link rel="preconnect" href="https://fonts.gstatic.com" crossorigin>
  <link href="https://fonts.googleapis.com/css2?family=Figtree:wght@400;600;700&family=Fraunces:opsz,wght@9..144,500;9..144,600&display=swap" rel="stylesheet">
  <link rel="stylesheet" href="/styles/tokens.css">
  <link rel="stylesheet" href="/styles/base.css">
  <link rel="stylesheet" href="/styles/components.css">
  <link rel="stylesheet" href="/styles/auth.css">
  <link rel="icon" href="/assets/tiles/modern/logo.svg" type="image/svg+xml">
  <html-script id="growme-i18n" type="application/json">
    $!{JSON.stringify(localeStrings).replace(/</g, "\\u003c")}
  </html-script>
  <html-script>
    (function () {
      var el = document.getElementById("growme-i18n");
      if (el) {
        try { window.__GROWME_I18N__ = JSON.parse(el.textContent || "{}"); }
        catch (e) { window.__GROWME_I18N__ = {}; }
      }
    })();
  </html-script>
</head>
<body class="auth-body">
  <a class="auth-back" href="/">${t("common.back")}</a>
  <AuthScreen/>
</body>
</html>
